import React, { useMemo, useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label ,FormGroup, Button, CardTitle, Modal, ModalHeader, ModalBody, Table} from "reactstrap";
import Breadcrumb from '../Common/Breadcrumb';
import TableContainer from '../Common/TableContainer';
import Select from 'react-select'
import axios from '../../axios';
import moment from 'moment';
import SweetAlert from "react-bootstrap-sweetalert"
import { Link } from "react-router-dom"
import Numeral from 'react-numeral';
import FileSaver from 'file-saver'
import Xl from 'excel4node'

function TimeAndAction() {


    const [companyhelp,setcompanyhelp]=useState([])
    const [Companyvalue, setCompanyvalue] = useState(JSON.parse(localStorage.getItem('company')))
    const [buyerhelp,setbuyerhelp]=useState([])
    const [buyervalue,setbuyervalue]=useState({label:"All",value:"0"})
    const [stylehelp,setstylehelp]=useState([])
    const [stylevalue,setstylevalue]=useState({label:"All",value:[0,"All"]})
    const [fromdate, setfromdate] = useState(new Date())
    const [todate, settodate] = useState(new Date())
    const [showtabel, setshowtabel] = useState(false)
    const [companyid, setcompanyid] = useState(JSON.parse(localStorage.getItem('company')))

    //dtlloop
    const [cpheader, setcpheader] = useState([])
    //cptopheading
    const [topheading, settopheading] = useState([])
    const [topheading1, settopheading1] = useState([])
    //cpdetails
    const [details, setdetails] = useState([])

    // const[statusvalue,setstatusvalue]=useState({label:"All", value:"All"})

    const [trackhelp, settrackhelp] = useState([])
    const [trackvalue, settrackvalue] = useState({label:"All",value:"0"})

    //nodatafound

    const [TimeAndActionNotFound, setTimeAndActionNotFound] = useState(false)
    const [TimeAndActionNotFound1, setTimeAndActionNotFound1] = useState(false)


    useEffect(() => {
        company()
        buyer()
        Trackname()

        var date =  new Date()
      
        var firstday =  new Date(date.getFullYear(), date.getMonth(),1)
       
        var lastday = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
        setfromdate(moment(firstday).format('YYYY-MM-DD'))
        settodate(moment(lastday).format('YYYY-MM-DD'))
        setCompanyvalue(JSON.parse(localStorage.getItem('company')))
    }, [])

    const statustype=[
        {label:"Completed",value:"Y"},
        {label:"Pending",value:"N"},
        {label:"All",value:"All"}
    ]


    const company=async()=>{
        await axios.instance.get("CompanyHelp/GetCompany")
        .then((res)=>{
            const data=res.data
            const option=data.map(row=>({
                "label":row.company,
                "value":row.companyId
            }))
            console.log(option,"companyhelp");
            setcompanyhelp(option)  
        }) 
    }

    const buyer=async()=>{
        await axios.instance.get("/BuyerHelp/BookedBuyerHelp")
        .then((res)=>{
            const data =res.data
            console.log(data,"buyerhelp")
            const option=data.map(row=>({
                "label":row.buyer,
                "value":row.buyerId
            }))
            // console.log(option,"buyerhelp")
            option.push({label:"All",value:0})
            setbuyerhelp(option)
        })
    }

    const style=async(value)=>{
        await axios.instance.get(`/StyleNoHelp/IpoNoStyle?buyerid=${value}&companyid=${Companyvalue.value}`)
        .then((res)=>{
            const data =res.data
            // console.log(res.data)
            const option=data.map(row=>({
                "label":row.ipoNo+' / '+row.style,
                 "value":[row.ipoNo,row.style]
            }))
            console.log(option,"ss")
            option.push({label:"All",value:[0,"All"]})
            setstylehelp(option)
        })
    }

    const Trackname=async()=>{
        await axios.instance.get(`/TrackNameHelp?companyid=${Companyvalue.value}`)
        .then((res)=>{
            const data =res.data
            console.log(res.data,'track')
            const option=data.map(row=>({
                "label":row.trackName,
                 "value":row.trackId
            }))
            console.log(option,"ss")
            // option.push({label:"All",value:0})
            settrackhelp(option)

            const option1=data.map(row=>({
                "label":row.trackName,
                 "value":row.trackId
            }))
            settopheading1(option1)
            settopheading(option)
        })
    }

    const cpViewData = async () =>{
        if(new Date(fromdate) >(new Date("1900-01-01"))  && new Date(todate) >(new Date("1900-01-01"))){
        setshowtabel(true)
        // settopheading([])
        setcpheader([])
        setdetails([])
        // await axios.instance.get(`/TimeAndAction?companyid=${Companyvalue.value}`)
        // .then((res)=>{
        //     console.log(res.data, 'topheading')
        //     settopheading(res.data)
        //     // res.data===''?settopheading([]) || setTimeAndActionNotFound(true):settopheading(res.data)
        //     })
           
            await axios.instance.get(`/TimeAndAction/criticalpathhdr?companyId=${Companyvalue.value}&buyerId=${buyervalue.value}&Style=${stylevalue.value[1]}&IpoNO=${stylevalue.value[0]}&fromDate=${fromdate}&toDate=${todate}`)
        .then((res)=>{
            console.log(res.data, 'header')
            setcpheader(res.data)
            // res.data===''?setcpheader([]) || setTimeAndActionNotFound(true) :setcpheader(res.data)
            })

            await axios.instance.get(`/TimeAndAction/criticalpathdtl?style=${stylevalue.value[1]}&ipoNo=${stylevalue.value[0]}&fromDate=${fromdate}&toDate=${todate}&trackId=${trackvalue.value}`)
        .then((res)=>{
            console.log(res.data, 'details')
            setdetails(res.data)
            res.data.length !== 0 ? setdetails(res.data) : setshowtabel(false) ||  settopheading([]) || setcpheader([]) || setdetails([]) ||  setTimeAndActionNotFound(true)
           handleDownload()
        })

        } else{
            setTimeAndActionNotFound1(true)
        }
    }

    const TimeAndActionExel = () => {

        let cpheaderexcel=[]
        const columns=[
            'Ipono',
            'Style',
            'Buyer',
            'Ship Date',
            'To Go',
            'Order Qty'
        ]

        let topheadings = []
        for(let data of topheading){
            topheadings.push(data.TrackName)
        }

        cpheader.map((data) => {
            // console.log(data)
            cpheaderexcel.push({
                'Ipono':data.Ipono.toString(),
                'Style':data.Style,
                'Buyer':data.Buyer,
                'ShipDate':data.ShipDDt,
                'ToGo':data.ToGo.toString(),
                'OrderQty':data.OrderQty.toString()
             })
             // console.log(Bookedorderdata,"excel")
           })


        const wb = new Xl.Workbook();
        const ws = wb.addWorksheet('T&A Status Tracking'); 
        var headings = wb.createStyle({
            font: {
                bold: true,
                size: 12,
                vertAlign: 'center'
            },
            alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true
            },
            border: {
                left: {
                    style: "thin"
                },
                right: {
                    style: "thin"
                },
                top: {
                    style: "thin"
                },
                bottom: {
                    style: "thin"
                }
            },
            fill: {
                type: 'pattern',
                patternType: 'solid',
                fgColor: '#ddd9c3'
            }
        });

        var heading1 = wb.createStyle({
            font: {
                bold: false,
                size: 12,
                vertAlign: 'center'
            },
            alignment: {
                horizontal:'right',
                vertical: 'center',
                wrapText: true
            },
            border: {
                left: {
                    style: "thin"
                },
                right: {
                    style: "thin"
                },
                top: {
                    style: "thin"
                },
                bottom: {
                    style: "thin"
                }
            }
        })

        var yellow = wb.createStyle({
            font: {
                bold: false,
                size: 12,
                vertAlign: 'center'
            },
            alignment: {
                horizontal: 'center',
                vertical: 'center'
            },
            border: {
                left: {
                    style: "thin"
                },
                right: {
                    style: "thin"
                },
                top: {
                    style: "thin"
                },
                bottom: {
                    style: "thin"
                }
            },
            fill: {
              type: 'pattern',
              patternType: 'solid',
              fgColor: 'FFFF00'
          }
            
            
        });

        var green = wb.createStyle({
            font: {
                bold: false,
                size: 12,
                vertAlign: 'center'
            },
            alignment: {
                horizontal: 'center',
                vertical: 'center'
            },
            border: {
                left: {
                    style: "thin"
                },
                right: {
                    style: "thin"
                },
                top: {
                    style: "thin"
                },
                bottom: {
                    style: "thin"
                }
            },
            
            fill: {
              type: 'pattern',
              patternType: 'solid',
              fgColor: '#94f794'
          }
            
        });

        var headingLeft = wb.createStyle({
            font: {
                bold: false,
                size: 12,
                vertAlign: 'center'
            },
            alignment: {
                horizontal: 'left',
                vertical: 'center',
                wrapText: true
                
            },
            border: {
                left: {
                    style: "thin"
                },
                right: {
                    style: "thin"
                },
                top: {
                    style: "thin"
                },
                bottom: {
                    style: "thin"
                }
            }
          })
  
    
    


        let headingColumnIndex = 1;
        columns.forEach(heading => {
          ws.column(headingColumnIndex).setWidth(30);
          ws.cell(8, headingColumnIndex++).string(heading).style(headings)  
        });


        let headingColumnIndex1 = 6;
        let MergeHeader = 6
        topheadings.forEach(heading => {
          ws.cell(8, headingColumnIndex1+=1, 8, headingColumnIndex1+=2, true)
          .string(heading).style(headings)  
          ws.cell(9, MergeHeader+=1).string('Plan Date').style(headings)
          ws.cell(9, MergeHeader+=1).string('Actual Date').style(headings)
          ws.cell(9, MergeHeader+=1).string('Devation').style(headings) 
        });


        let rowIndex = 10;
        cpheaderexcel.forEach( record => {
        let columnIndex = 1;
        Object.keys(record ).forEach(columnName =>{
            console.log(columnName)
            ws.column(columnIndex).setWidth(30);
            
          columnIndex === 1 || columnIndex === 5 || columnIndex === 6 ?
          ws.cell(rowIndex,columnIndex).style(heading1) :
          ws.cell(rowIndex,columnIndex).style(headingLeft)
            
            ws.cell(rowIndex,columnIndex++)
                .string(record [columnName])
        });
        rowIndex++;
        });


        let rowIndex1 = 10
        let columnIndex7 = 6
        for(const data of cpheader){
            for(const task of topheading){
                const Dtl = details.filter(d1=>  d1.TANo === data.TANo && d1.TrackId===task.Trackid)
                for(const data3 of Dtl){
                    if(data3.Devation >0 && data3.Status==='Y'||data3.Status==='N'){
 
                            {data3.PlanDt===''|| data3.ActualDt==="'" ||data3.ActualDt===''?ws.cell(rowIndex1,columnIndex7+=1).string(data3.TrackId===task.Trackid?data3.PlanDt:'').style(heading1):ws.cell(rowIndex1,columnIndex7+=1).string(data3.TrackId===task.Trackid?data3.PlanDt:'').style(green)}
                            {data3.ActualDt==="'" || data3.ActualDt===''?ws.cell(rowIndex1,columnIndex7+=1).string(data3.ActualDt===''?'':data3.ActualDt).style(heading1):ws.cell(rowIndex1,columnIndex7+=1).string(data3.ActualDt===''?'':data3.ActualDt).style(green)}
                            {data3.Devation===0 || data3.ActualDt==="'" ||data3.ActualDt===''?ws.cell(rowIndex1,columnIndex7+=1).string(data3.Status==='Y' || data3.Status==='N'?data3.Devation.toString():'').style(heading1):ws.cell(rowIndex1,columnIndex7+=1).string(data3.Status==='Y' || data3.Status==='N'?data3.Devation.toString(): '').style(green)}
                    }else{
                            {data3.PlanDt===''|| data3.ActualDt==="'" ||data3.ActualDt===''?ws.cell(rowIndex1,columnIndex7+=1).string(data3.TrackId===task.Trackid?data3.PlanDt:'').style(heading1):data3.ActualDt===''?ws.cell(rowIndex1,columnIndex7+=1).string(data3.TrackId===task.Trackid?data3.PlanDt:'').style(heading1):ws.cell(rowIndex1,columnIndex7+=1).string(data3.TrackId===task.Trackid?data3.PlanDt:'').style(yellow)}
                            {data3.ActualDt===''|| data3.ActualDt==="'" ||data3.ActualDt===''?ws.cell(rowIndex1,columnIndex7+=1).string(data3.ActualDt===''?'':data3.ActualDt).style(heading1):data3.ActualDt===''?ws.cell(rowIndex1,columnIndex7+=1).string(data3.ActualDt===''?'':data3.ActualDt).style(heading1): ws.cell(rowIndex1,columnIndex7+=1).string(data3.ActualDt===''?'':data3.ActualDt).style(yellow)}
                            {data3.Devation ===0|| data3.ActualDt==="'" ||data3.ActualDt==='' ? ws.cell(rowIndex1,columnIndex7+=1).string(data3.Status === 'Y' || data3.Status==='N' ?   data3.Devation.toString(): '').style(heading1):  data3.ActualDt === ''  ? ws.cell(rowIndex1,columnIndex7+=1).string(data3.Status === 'Y' || data3.Status==='N'?   data3.Devation.toString():'').style(heading1) : ws.cell(rowIndex1,columnIndex7+=1).string(data3.Status === 'Y' || data3.Status==='N'?   data3.Devation.toString():'').style(yellow)} 
                    }
                }
            }
            rowIndex1++
                columnIndex7 = 6
        }


        ws.cell(1, 1, 1, 15, true).string('Time And Action').style(headings);

        ws.cell(3, 1).string('Company').style(headings);
        ws.cell(3, 2).string(Companyvalue.label).style(headings);

        ws.cell(3, 4).string('Buyer').style(headings);
        ws.cell(3, 5).string(buyervalue.label).style(headings);

        ws.cell(5, 1).string('IPO No / Style').style(headings);
        ws.cell(5, 2).string(stylevalue.label).style(headings);

        ws.cell(5, 4).string('Task Name').style(headings);
        ws.cell(5, 5).string(trackvalue.label).style(headings);
        
        ws.cell(3, 7).string('From Date').style(headings);
        ws.cell(3, 8).string(moment(fromdate).format("DD-MM-yyyy")).style(headings);

        ws.cell(3, 10).string('To Date').style(headings);
        ws.cell(3, 11).string(moment(todate).format("DD-MM-yyyy")).style(headings);    

        wb.writeToBuffer().then(function(buffer) {
            //console.log(buffer)
            const data = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
            //console.log(datas)
            FileSaver.saveAs(data,  'T&A Status Tracking' + ".xlsx")
        });
}

const customStyles = {
    valueContainer: base => ({
      ...base,
      maxHeight: 100, // set a max height for the scrollable viewport
      overflowY: "scroll", // enable vertical scrolling
    }),
    multiValue: base => ({
      ...base,
      maxWidth: "70%", // set a max width to prevent overflow
      overflow: "hidden", // hide overflow
      textOverflow: "ellipsis", // add an ellipsis for truncated text
    }),
}

const handleDownload = async() => {
    const value =   await axios.instance.get(`/TimeAndAction/Exporttnastatus?buyers=${buyervalue.label}&companys=${Companyvalue.label}&companyid=${Companyvalue.value}&companyId=${Companyvalue.value}&buyerId=${buyervalue.value}&style=${stylevalue.label}&ipoNo=${stylevalue.value[0]}&Style=${stylevalue.label}&IpoNO=${stylevalue.value[0]}&fromDate=${moment(fromdate).format('YYYY-MM-DD')}&toDate=${moment(todate).format('YYYY-MM-DD')}&trackId=${trackvalue.value}`, { responseType: 'blob' })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
               // window.open(response.data, '_blank');
            
               // const link = document.createElement('a');
               // link.href = url;
              //  link.setAttribute('download', 'PO_Status.xlsx');
               // document.body.appendChild(link);
              //  window.open(link)
               // link.click();
 
               
            })
           // window.open(value)
            .catch(error => {
                console.error('Error downloading Excel file:', error);
            });
    };   


    const ExporttoExcelConsolidate = async() => {
        // await  axios.instance.get('/GetDepartmentSalarySummary', { responseType: 'blob'})
             
         // .then((res) => {
            // const xlBlob = new Blob([res.data] ,{type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'})
            // FileSaver.saveAs(xlBlob , `${fileName}.xlsx`)
       //         localStorage.setItem('pdf', pdfBlob)
       //const value = BookedOrder;
      //  var date =  new Date()
    
    
       const now = new Date();
      const year = now.getFullYear();
      const month = now.toLocaleString('default', { month: 'long' });
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const amPm = hours >= 12 ? 'PM' : 'AM';
  const date =(`${month}_${day}_${year}_${hours}_${minutes}_${amPm}`)
      await window.open(`http://103.27.85.36/ExcelFilewebmins/Time&Action_${date}.xlsx`)
   // await window.open(`http://192.168.1.2/Wbei/ExcelFile/Time&Action_${date}.xlsx`)
          // })
       }
  return (
    <React.Fragment>
        <div className="account-pages my-5 pt-5 m-3 pt-sm-5">
            <Container fluid={true}>
                <Card style={{backgroundColor:"white"}}>
                    <CardBody className="p-4">
                        <Row>
                            <Col>
                                <Breadcrumb title="Report" breadcrumbItem="T&A Status Tracking" />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm='12' md='12' lg='4'>
                                <FormGroup> 
                                    <Label for='excompany'>
                                        Company
                                    </Label>         
                                    <Select 
                                        onChange={(value) => {
                                            console.log(value)
                                            setCompanyvalue(value)
                                            // localStorage.setItem('company',JSON.stringify(value))
                                            Trackname()
                                        }}
                                        value={Companyvalue}
                                        options={companyhelp}
                                        styles={{
                                            menuPortal: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            }),
                                            menu: (provided, state) => ({
                                            ...provided,
                                            height: 'auto',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='12' lg='4'>
                                <FormGroup> 
                                    <Label for='exbuyer'>
                                        Buyer
                                    </Label>         
                                    {/* <Input id='exbuyer' name='Buyer' type='select'>
                                        <option>--Select--</option>
                                    </Input> */}
                                    <Select
                                        name="Buyer"
                                        value={buyervalue}
                                        onChange={(value)=>{
                                            // console.log(value.value,"buyervalue")
                                            setbuyervalue(value)
                                            style(value.value)
                                            // bookedorder(value.value)
                                            console.log(value.value,"buyervalue")
                                        }}
                                        options={buyerhelp}
                                        styles={{
                                            menuPortal: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            }),
                                            menu: (provided, state) => ({
                                            ...provided,
                                            height: 'auto',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='12' lg='4'>
                                <FormGroup> 
                                    <Label for='exstyleno'>
                                    IPO No / Style
                                    </Label>         
                                    {/* <Input id='exstyleno' name='Style No' type='select'>
                                        <option>--Select--</option>
                                    </Input> */}
                                    <Select
                                        name="Style No"
                                        value={stylevalue}
                                        onChange={(value)=>{
                                            console.log(value.value[0],"stylevalue")
                                            console.log(value.label,"stylelabel")
                                            setstylevalue(value) 
                                        }}
                                        options={stylehelp}
                                        styles={{
                                            menuPortal: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            }),
                                            menu: (provided, state) => ({
                                            ...provided,
                                            height: 'auto',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </FormGroup>
                            </Col>
                            {/* <Col sm='12' md='6' lg='3'>
                                <FormGroup> 
                                <Label for='trackname'>
                                        Task Name 
                                    </Label>         
                                    <Select
                                        name="trackname"
                                        value={trackvalue}
                                        onChange={(value)=>{
                                            settrackvalue(value)
                                            // style(value.value)
                                            // console.log(value.value,"stylevalue")
                                        }}
                                        options={trackhelp}
                                        styles={{
                                            menuPortal: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            }),
                                            menu: (provided, state) => ({
                                            ...provided,
                                            height: 'auto',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </FormGroup>
                            </Col> */}
                        </Row>
                        <Row>
                            <Col sm='12' md='12' lg='2'>
                                <FormGroup> 
                                    <Label for='exfromdate'>
                                   Planned From Date
                                    </Label>         
                                    <Input id='exfromdate' name='Date' type='date' 
                                        value={fromdate}
                                        onChange={(e)=> setfromdate(e.target.value)}
                                        min="1900-01-01" maxLength='4' max="9999-12-31"
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='12' lg='2'>
                                <FormGroup> 
                                    <Label for='extodate'>
                                    Planned To Date
                                    </Label>         
                                    <Input id='extodate'
                                        onChange={(e)=> settodate(e.target.value)}
                                        min="1900-01-01" maxLength='4' max="9999-12-31"
                                        value={todate}
                                        name='ToDate' type='date' />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='12' lg='8'>
                                <div className="mb-3">
                                <Label htmlFor="manufacturerbrand">
                                    <b> Grid Filter</b>
                                </Label>
                                <Select
                                    isMulti
                                    value={topheading1}
                                    onChange={value => {
                                        settopheading1(value)
                                        settopheading(value)
                                        console.log(value)
                                    }}
                                    styles={customStyles}
                                    options={trackhelp}
                                />
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col className="d-flex justify-content-end">
                                {/* <Button color='primary' size='md' className="mx-1" onClick={()=>{cpViewData()}}>View</Button>
                                <Button size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47'}}    className="btn btn-sm btn-primary"  onClick={()=>{ExporttoExcelConsolidate()}}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button> */}
                                 <Button size='md' className="mx-1 w-lg" style={{backgroundColor:'#0E21A0',color:'white',fontWeight:'bolder'}} onClick={()=>{cpViewData()}}>View</Button>
                          <Button size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47',fontWeight:'bolder'}}    className="btn btn-sm btn-primary w-lg"  onClick={()=>{ExporttoExcelConsolidate()}}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button>
                            </Col>
                        </Row>

                        {showtabel && (
                        <div className="mt-5 table-responsive">
                            <Table className=' table table-bordered border-0 table-sm' style={{cursor:'pointer'}}>
                                <thead>
                                    <tr className="text-nowrap" style={{backgroundColor:'#11244C',color:'white'}}>
                                        <th>SNo</th>
                                        <th>IPO NO</th>
                                        <th>Style</th>
                                        <th>Buyer</th>
                                        <th>Ship Date</th>
                                        <th>To Go</th>
                                        <th>Order Qty</th>
                                        {topheading.map((data,index)=>(
                                        <th key={index} className="text-center" colSpan='3'>{data.label}</th>))}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="text-nowrap" style={{backgroundColor:'#11244C',color:'white'}}>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        {topheading.map((data,index)=>(
                                            <>
                                            <th>Plan Date</th>
                                            <th>Actual</th>
                                            <th>Deviation</th>
                                            </>
                                            ))}
                                    </tr>
                                    {cpheader.map((data,index)=>(
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        <td className="text-end">{data.Ipono}</td>
                                        <td className="text-start">{data.Style}</td>
                                        <td className="text-start">{data.Buyer}</td>
                                        <td className="text-start">{data.ShipDDt}</td>
                                        <td className="text-end">{data.ToGo}</td>
                                        <td className="text-end">{data.OrderQty}</td>
                                        
                                        <>
                                        {topheading.map((task ) => {
                                            return<>
                                            {/* {console.log(task)} */}

                                                {details.filter(d1=>  d1.TANo === data.TANo && d1.TrackId===task.value).map((data3, index) => {
                                                    // console.log(data3.TANo,"tano");
                                                    // console.log(data.TANo,'tano1');
                                                    // console.log(data3.TrackId,"trackid");
                                                    // console.log(task.Trackid,"trackid1");
                                                    
                                                   
                                                    return<>
                                                     {data3.Devation >0 && data3.Status==='Y'||data3.Status==='N' ?(
                                                        <>
                                                        
                                                            {data3.PlanDt===''|| data3.ActualDt==="'" ||data3.ActualDt===''?<td style={{fontSize:"13px",backgroundColor:'#Fafafa'}}  key={index} className="text-start">{data3.TrackId===task.value?data3.PlanDt:''}</td>:<td style={{fontSize:"13px",backgroundColor:'#94f794'}} className="text-start">{data3.TrackId===task.value?data3.PlanDt:''}</td>}
                                                            {data3.ActualDt==="'" || data3.ActualDt===''?<td style={{fontSize:"13px",backgroundColor:'#Fafafa'}} className="text-start"> {data3.ActualDt===''?'':data3.ActualDt}</td>:<td  style={{fontSize:"13px",backgroundColor:'#94f794'}} className="text-start">{data3.ActualDt===''?'':data3.ActualDt}</td>}
                                                            {data3.Devation===0 || data3.ActualDt==="'" ||data3.ActualDt===''?<td style={{fontSize:"13px",backgroundColor:'#Fafafa'}} className="text-end">{data3.Status==='Y' || data3.Status==='N'?data3.Devation:''}</td>:<td  style={{fontSize:"13px",backgroundColor:'#94f794'}} className="text-end">{data3.Status==='Y' || data3.Status==='N'?data3.Devation: ''}</td>}
                                                        </>
                                                         ): 
                                                         <> 
                                                            {data3.PlanDt===''|| data3.ActualDt==="'" ||data3.ActualDt===''?<td scope="col"  style={{fontSize:"13px",backgroundColor:'#Fafafa'}} key={index}  className="text-start">{data3.TrackId===task.value?data3.PlanDt:''}</td>:data3.ActualDt===''?<td scope="col"  style={{fontSize:"13px",backgroundColor:'#fafafa'}} key={index}  className="text-start">{data3.TrackId===task.value?data3.PlanDt:''}</td>:<td scope="col"  style={{fontSize:"13px",backgroundColor:'yellow'}} key={index} className="text-start">{data3.TrackId===task.value?data3.PlanDt:''}</td>}
                                                            {data3.ActualDt===''|| data3.ActualDt==="'" ||data3.ActualDt===''?<td scope="col"  style={{fontSize:"13px",backgroundColor:'#Fafafa'}} key={index} className="text-start">{data3.ActualDt===''?'':data3.ActualDt}</td>:data3.ActualDt===''?<td scope="col"  style={{fontSize:"13px",backgroundColor:'#fafafa' }}  className="text-start">{data3.ActualDt===''?'':data3.ActualDt}</td>: <td scope="col"  style={{fontSize:"13px",backgroundColor:'yellow' }} className="text-start">{data3.ActualDt===''?'':data3.ActualDt} </td>}
                                                            {data3.Devation ===0|| data3.ActualDt==="'" ||data3.ActualDt==='' ? <td scope="col"  style={{fontSize:"13px",backgroundColor:'#fafafa' }} className="text-end" >{data3.Status === 'Y' || data3.Status==='N' ?   data3.Devation: ''} </td> :  data3.ActualDt === ''  ? <td scope="col"  style={{fontSize:"13px",backgroundColor:'#fafafa' }} className="text-end">{data3.Status === 'Y' || data3.Status==='N'?   data3.Devation:''} </td>  : <td scope="col"  style={{fontSize:"13px",backgroundColor:'yellow' }} className="text-end">{data3.Status === 'Y' || data3.Status==='N'?   data3.Devation:''} </td>} 
                                                        </> 
                                                    
                                                    }  
                                                    </>
                                                })}
                                            </>
                                        })}
                                        </>
                                         
                                       
                                    </tr>
                                    ))}   
                                </tbody>

                            </Table>
                        </div>
                        )}
                    </CardBody>
                </Card>
            </Container>

            {TimeAndActionNotFound ? (
                <SweetAlert
                    title="No Data Found"
                    timeout={2000}
                    style={{
                    position: "absolute",
                        justifyContent:'center',
                        alignItems:'center'
                    }}
                    showCloseButton={false}
                    showConfirm={false}
                    warning
                    onConfirm={() => {
                        setTimeAndActionNotFound(false);
                    }}
                ></SweetAlert>
                ) : null}

{TimeAndActionNotFound1 ? (
                <SweetAlert
                    title="Invalid Date"
                    timeout={2000}
                    style={{
                    position: "absolute",
                        justifyContent:'center',
                        alignItems:'center'
                    }}
                    showCloseButton={false}
                    showConfirm={false}
                    warning
                    onConfirm={() => {
                        setTimeAndActionNotFound1(false);
                    }}
                ></SweetAlert>
                ) : null}

        </div>
    </React.Fragment>
  )
}

export default TimeAndAction